class TestimonialCarousel extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.Imageitems = this.querySelectorAll('.testimonial__item-img');
    this.testimonialItemContent = this.querySelectorAll('.testimonial__item-content');
    this.prevButton = this.querySelector('.testimonial__item-btn-prev');
    this.nextButton = this.querySelector('.testimonial__item-btn-next');
    this.prevButton.addEventListener('click', this.showPrevItem.bind(this));
    this.nextButton.addEventListener('click', this.showNextItem.bind(this));
    this.showItem(this.currentIndex);
  }

  showItem(index) {
    this.testimonialItemContent.forEach((item) => {
      item.parentElement.classList.remove('transform--active');
      item.classList.remove('testimonial--active');
      item.classList.add('testimonial--inactive');
    });
    this.Imageitems.forEach((Imageitem) => {
      Imageitem.classList.remove('testimonial-img--active');
      Imageitem.classList.add('testimonial-img--inactive');
    });

    const parentElement = this.Imageitems[index].parentElement;
    const cardColor = this.Imageitems[index].getAttribute('data-media');
    parentElement.style.setProperty('--bg-color', cardColor);
    parentElement.classList.add('transform--active');
    parentElement.classList.remove('transform--inactive');
    this.testimonialItemContent[index].classList.add('testimonial--active');
    this.testimonialItemContent[index].classList.remove('testimonial--inactive');
    this.Imageitems[index].classList.add('testimonial-img--active');
    this.Imageitems[index].classList.remove('testimonial-img--inactive');
    this.currentIndex = index;

    setTimeout(() => {
      parentElement.classList.remove('transform--active');
      parentElement.classList.add('transform--inactive');
    }, 500);
  }

  showPrevItem() {
    let index = this.currentIndex - 1;
    if (index < 0) {
      index = this.Imageitems.length - 1;
    }
    this.showItem(index);
  }

  showNextItem() {
    let index = this.currentIndex + 1;
    if (index >= this.Imageitems.length) {
      index = 0;
    }
    this.showItem(index);
  }
}

customElements.define('main-testimonials', TestimonialCarousel);
